module.exports = __webpack_public_path__ + "media/images/icons/choose_file-c42c1229291a0399989ba0509b42f12a.png";